import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=018ffd6d&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "../../theme/slider.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Slider.vue?vue&type=style&index=1&id=018ffd6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ffd6d",
  null
  
)

export default component.exports